class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // passe o event para o handler
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(event) {
    // aguarda o próximo tick para o foco "assentar"
    setTimeout(() => {
      // se o mouse ainda está sobre o componente ou o painel, não feche
      const isHovering =
        this.matches(':hover') ||
        this.mainDetailsToggle.matches(':hover') ||
        (this.content && this.content.matches(':hover'));

      const isFocusInside = this.contains(document.activeElement);

      // opcional: se houver relatedTarget e ele estiver dentro, também não feche
      const movedToInside =
        event && event.relatedTarget ? this.contains(event.relatedTarget) : false;

      if (!isHovering && !isFocusInside && !movedToInside) {
        this.close();
      }
    }, 0);
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      // mantenha aria em sincronia
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    } else {
      this.animations.forEach((animation) => animation.cancel());
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
}
customElements.define('details-disclosure', DetailsDisclosure);